import { ContactsMockApi } from 'app/mock-api/apps/contacts/api';
import { ECommerceInventoryMockApi } from 'app/mock-api/apps/ecommerce/inventory/api';
import { AuthMockApi } from 'app/mock-api/common/auth/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { UserMockApi } from 'app/mock-api/common/user/api';
import { ProjectMockApi } from 'app/mock-api/dashboards/project/api';

export const mockApiServices = [
    AuthMockApi,
    ContactsMockApi,
    ECommerceInventoryMockApi,
    NavigationMockApi,
    ProjectMockApi,
    UserMockApi,
];
